import {
  CLIENT_TYPE_BROWSER,
  INITIAL_PAPER_TYPE,
  PAGES_MIN,
  USER_ROLE_OPERATOR,
  USER_ROLE_SEO,
  USER_ROLE_WRITER,
  WORDS_MIN,
} from '../constants';
import { getDefaultDate } from '../utils';

export const initialValues = {
  login: '',
  paper_type: INITIAL_PAPER_TYPE,
  pages_qty: PAGES_MIN,
  words_qty: WORDS_MIN,
  'paper-size-type': 'pages',
  deadline_datetime: getDefaultDate(),
  stay_signed_in: true,
  writer_req_slug: '',
  policy_agree: false,
  marketing_agree: false,
  title: '',
  client_type: CLIENT_TYPE_BROWSER,
  captcha_token: '',
  login_ability: false,
  showWriter: false,
  showGdpr: false,
  showTitle: false,
};

export const DISABLED_ROLES = [USER_ROLE_SEO, USER_ROLE_OPERATOR, USER_ROLE_WRITER];

export const subscription = {
  submitting: true,
  values: false,
  validating: true,
  submitSucceeded: true,
  submitFailed: true,
  submitError: true,
  hasSubmitErrors: true,
  dirtySinceLastSubmit: true,
};
